<template>
  <div style="overflow-x: auto">
    <table class="kalem-tablo">
      <thead>
        <tr>
          <th>Tip</th>
          <th>Açıklama</th>
          <th>Bilet No</th>
          <th class="sag">Matrah</th>
          <th class="sag">KDV</th>
          <th class="sag">Oran</th>
          <th class="sag">Tutar</th>
          <th>Muh. Kod</th>
          <th>KDV Kod</th>
          <th>Masraf / Proje</th>
          <!-- Alista ve iadede istisna kavrami yok; bkz. muafiyetVar. -->
          <th v-if="muafiyetVar">Muafiyet</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(s, i) in fatura.Satirlar" :key="i">
          <td>
            <v-chip small :class="TipRengi(s.Tip) + ' white--text'">
              {{ s.TipAdi }}
            </v-chip>
          </td>
          <td>{{ s.Aciklama }}</td>
          <td>
            <!--
              Bilet numarasi bilet ekranina baglanir. Adres bilet numarasi
              tek basina degil, havayolu kodu ve ucus tipiyle cozuluyor;
              ikisi eksikse baglanti verilmez.
            -->
            <a
              v-if="BiletAcilabilir(s)"
              target="_blank"
              :href="BiletAdresi(s)"
              >{{ s.BiletNo }}</a
            >
            <span v-else>{{ s.BiletNo }}</span>
          </td>
          <td class="sag">{{ Para(s.Matrah) }}</td>
          <td class="sag">{{ Para(s.Kdv) }}</td>
          <td class="sag">
            <span v-if="s.KdvOrani">%{{ s.KdvOrani }}</span>
            <span v-else class="grey--text">—</span>
          </td>
          <td class="sag font-weight-bold">{{ Para(s.Tutar) }}</td>
          <td>
            <!--
              Kod, kaleme DEGIL kalemin kombinasyonuna baglidir (kalem tipi
              + hat + KDV durumu). Duzenleme penceresini acmak ust bilesene
              birakiliyor - istek atan is bu bilesenin isi degil.
            -->
            <span v-if="s.MuhasebeKod">{{ s.MuhasebeKod }}</span>
            <span v-else class="red--text">tanımsız</span>
            <v-btn
              icon
              small
              class="ma-0"
              title="Bu kalemin muhasebe kodunu düzenle"
              @click="$emit('kod-duzenle', s)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </td>
          <td>
            <span v-if="s.KdvMuhasebeKod">{{ s.KdvMuhasebeKod }}</span>
            <span v-else class="grey--text">—</span>
          </td>
          <td>
            <div>{{ s.MasrafMerkezi }}</div>
            <div class="grey--text">{{ s.ProjeKodu }}</div>
          </td>
          <td v-if="muafiyetVar">
            <!--
              Muafiyet kodu doluysa satir KDV'ye tabi degildir; nedeni cogu
              kurulumda bos birakiliyor.
            -->
            <span v-if="s.MuafiyetKodu">
              {{ s.MuafiyetKodu }}
              <span v-if="s.MuafiyetNedeni" class="grey--text">
                {{ s.MuafiyetNedeni }}
              </span>
            </span>
            <span v-else class="grey--text">—</span>
          </td>
        </tr>
      </tbody>
      <!--
        Kalemler uzun listeler halinde okunuyor; altta toplam gormek isten
        kolaylik. (Bir donem listede genisletilmis satirda da ciziliyordu
        ve orada gereksizdi; o ozellik performans nedeniyle kaldirildi.)
      -->
      <tfoot>
        <tr class="kalem-toplam">
          <td colspan="3">{{ fatura.SatirSayisi }} kalem</td>
          <td class="sag">{{ Para(fatura.ToplamMatrah) }}</td>
          <td class="sag">{{ Para(fatura.ToplamKdv) }}</td>
          <td></td>
          <td class="sag">{{ Para(fatura.ToplamNet) }}</td>
          <!--
            Muh. Kod, KDV Kod, Masraf/Proje ve (muafiyetVar ise) Muafiyet.
            Son hucre ayri ve basliktaki ile AYNI kosulda: dort kolonluk tek
            bir birlesik hucre alista tabloya hayali bir kolon eklerdi.
          -->
          <td colspan="3"></td>
          <td v-if="muafiyetVar"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
/**
 * Bir faturanin kalemlerini gosteren tablo.
 *
 * Satir ayrinti penceresinde kullaniliyor. Bir donem listedeki
 * genisletilmis satirda da ciziliyordu; o ozellik UI performansi nedeniyle
 * kaldirildi, bilesen ayri kaldi cunku tablo yeterince buyuk ve sayfanin
 * kendi mantigiyla karistirmaya degmiyor.
 *
 *
 * Bilesen ISTEK ATMAZ ve HICBIR SEYI DEGISTIRMEZ: yalnizca cizer. Kod
 * duzenleme "kod-duzenle" olayiyla ust bilesene birakiliyor, cunku
 * kaydetme sonrasi listenin tazelenmesi de orasinin isi.
 */
import kalemrenkleri from "@/components/app/entegrasyon/kalemrenkleri.js";

export default {
  name: "kalemtablosu",

  props: {
    /**
     * Satirlar, SatirSayisi ve ToplamMatrah / ToplamKdv / ToplamNet tasiyan
     * nesne. Fatura ozeti bu bicimde; maliyet ve iade ozetini sayfa bu
     * bicime cevirip veriyor (dismuhasebeaktarim.vue satirBelgesi).
     */
    fatura: { type: Object, required: true },

    /**
     * Alis (maliyet ya da alis iadesi) belgesi mi. Aciksa Muafiyet kolonu
     * cizilmez: alista istisna kavrami yok. KDV kolonlari KALIR - ic hat
     * alislarinda KDV ayriliyor.
     */
    alis: { type: Boolean, default: false },

    /**
     * Istisna kavrami olmayan SATIS tarafi belgesi mi (satis iadesi
     * dekontu). Aciksa Muafiyet kolonu yine cizilmez. alis bayragindan ayri
     * cunku belge alis degil: ileride alisa ozgu bir kolon eklenirse satis
     * iadesine tasinmasin.
     */
    istisnasiz: { type: Boolean, default: false },
  },

  computed: {
    /**
     * Muafiyet kolonu cizilir mi: yalnizca satis faturasinda. Baslik, govde
     * ve dip toplamdaki kosullu hucreler bu TEK degere bagli; ayri ayri
     * yazilsaydi biri unutulup kolonlar kayardi.
     */
    muafiyetVar() {
      return !this.alis && !this.istisnasiz;
    },
  },

  methods: {
    /** Kalem tipinin rengi; serit ile ayni kaynaktan. */
    TipRengi: kalemrenkleri.TipRengi,

    /**
     * Bilet ekrani adresi.
     *
     * Bicim projedeki diger ekranlarla ayni (bkz. bilet/index.vue):
     *   #/bilet/yeni/id?isl=get&hyolukod=<HY>&biletno=<NO>&ucustipi=<I|D|B>
     *
     * isl HER ZAMAN "get": index.vue void biletlerde "voidget" kullaniyor
     * ama bu listenin kaynak sorgusu yalnizca B_Status "S" ve "Ia" olan
     * biletleri getiriyor, void bilet buraya hic girmiyor.
     */
    BiletAdresi(satir) {
      return (
        "#/bilet/yeni/id?isl=get" +
        "&hyolukod=" + encodeURIComponent(satir.HavayoluKodu) +
        "&biletno=" + encodeURIComponent(satir.BiletNo) +
        "&ucustipi=" + encodeURIComponent(satir.UcusTipi)
      );
    },

    /**
     * Bilet ekrani acilabilir mi. Uc parcanin ucu de gerekli; biri eksikken
     * baglanti vermek kullaniciyi bos bir ekrana gotururdu.
     */
    BiletAcilabilir(satir) {
      return !!(satir.BiletNo && satir.HavayoluKodu && satir.UcusTipi);
    },

    /** Tutar bicimi; sayfadakiyle ayni. */
    Para(deger) {
      if (deger === null || deger === undefined) return "";
      return Number(deger).toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
/* v-data-table kullanilmadi: burada sayfalama, siralama ve secim
   istenmiyor - kalemler oldugu gibi, fatura sirasinda okunmali. */
.kalem-tablo {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.kalem-tablo th,
.kalem-tablo td {
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;

  /* Kolonlar ICERIGI kadar daralsin. Tablo width:100% oldugu icin artan
     genislik aksi halde TUM otomatik kolonlara dagiliyordu; sayi kolonlari
     sagta yasli oldugundan bu, hucre icinde buyuk bosluklar olarak
     goruluyordu (orn. Bilet No ile Matrah arasi). Fazlaligin tamami
     asagida SON kolona veriliyor. */
  width: 1%;
}

.kalem-tablo th {
  font-size: 11px;
  letter-spacing: 0.5px;
  color: #757575;
  text-transform: uppercase;
  border-bottom: 1px solid #bdbdbd;
}

/* DIKKAT - secicilerin basindaki thead/tbody ZORUNLU: nth-child kolonu
   degil ELEMANI sayiyor ve dip toplam satirinin ilk hucresi colspan="3".
   Orada td:nth-child(2) MATRAH hucresine denk geliyordu, dolayisiyla
   asagidaki min-width matrah kolonunu 260px'e sisiriyordu. Kolon
   genisligi olcerek bulundu (Matrah tam 260px cikiyordu).

   Aciklama uzun; tek satirda kalmasi tabloyu asiri genisletiyordu. Sarma
   aciksa da kolon SABIT: genisleyen kolon en sagdaki. */
.kalem-tablo thead th:nth-child(2),
.kalem-tablo tbody td:nth-child(2) {
  white-space: normal;
  min-width: 260px;
}

/* Artan genisligin TAMAMI en son kolona gidiyor; veri kolonlari boylece
   yan yana kaliyor. Alista ve iadede Muafiyet cizilmedigi icin son kolon Masraf /
   Proje olur ve kural ona kendiliginden gecer. Dip toplam yine disarida:
   oradaki hucreler colspan tasiyor ve genislik birden fazla kolona
   dagitilirdi. */
.kalem-tablo thead th:last-child,
.kalem-tablo tbody td:last-child {
  width: 100%;
}

.kalem-tablo .sag {
  text-align: right;
}

.kalem-tablo tbody tr:hover {
  background: #fafafa;
}

.kalem-toplam td {
  border-top: 2px solid #bdbdbd;
  border-bottom: none;
  font-weight: 600;
}
</style>
